import styled from 'styled-components';
import Link from '@material-ui/core/Link';
const StyledLink = styled(Link)`
  color: #005099 !important;
  font-size: 16px;
  line-height: 24px;
  font-family: 'OpenSans-Regular';
  font-weight: 400;
`;
export default StyledLink;